import { useCallback, useEffect, useState } from 'react';
import {
  PowerBiReportDto,
  useGetOrganizationPowerBiReports,
  useGetSingleOrganizationPowerBiReport,
} from '@sib/api';
import { useUserSetupStore } from '@sib/auth';

// TODO: Ask BE to define it properly
interface PowerBiReportObject {
  id: string;
}

export const usePowerBiReports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [powerBiReports, setPowerBiReports] = useState<PowerBiReportDto[]>([]);
  const organizationId = useUserSetupStore(state => state.organizationId);

  const { data } = useGetOrganizationPowerBiReports({ organizationId });
  const { mutateAsync: fetchReportDetails } =
    useGetSingleOrganizationPowerBiReport();

  const fetchAllReportDetails = useCallback(async () => {
    setIsLoading(true);
    if (data?.items) {
      const reports = await Promise.allSettled(
        data.items.map(async report => {
          const { id } = report as PowerBiReportObject;

          return fetchReportDetails({ reportId: id, organizationId });
        })
      );

      const fulfilledReports = reports
        .filter(
          (report): report is PromiseFulfilledResult<PowerBiReportDto> =>
            report.status === 'fulfilled'
        )
        .map(report => report.value);

      setPowerBiReports(fulfilledReports);
    }
    setIsLoading(false);
  }, [data?.items, fetchReportDetails, organizationId]);

  useEffect(() => {
    fetchAllReportDetails();
  }, [fetchAllReportDetails]);

  return {
    powerBiReports,
    isLoading,
  };
};
